export {
  getStaticProps,
  SupportPage as default,
} from '@cinch-nx/landing-feature-support'
